import { Reveal } from "@/components/Reveal";

export const TRADES = [
  "Cleaning",
  "Handyman / small repairs",
  "Furniture assembly",
  "Gardening",
  "Plumbing",
  "Electrical",
  "Painting",
  "Airbnb turnover",
  "Moving & removals",
  "Pool maintenance",
  "AC / air conditioning servicing",
  "Pest control",
  "TV mounting & smart home setup",
  "Other",
];

const STEPS = [
  {
    n: "01",
    title: "Register in one minute",
    text: "Your name, your trade, the part of Malta you cover and a WhatsApp number. No documents, no fee, no commitment.",
  },
  {
    n: "02",
    title: "We call you within 48 hours",
    text: "One short call about how much work you usually take on and when, the rates you charge today, the areas you cover, and what would make a platform like this genuinely useful to you.",
  },
  {
    n: "03",
    title: "Priority placement at launch",
    text: "Founding professionals are listed first when the app opens in Malta, and pay 0% commission on their first 5 jobs, or for 60 days after their first job — whichever comes first.",
  },
];

const CALL_TOPICS = [
  "Number of units and typical turnover window",
  "Your current rates and how you are paid",
  "Which parts of the island you cover",
  "What would make a platform worth using",
];

export const Trades = () => (
  <section className="section" data-testid="trades-section">
    <div className="wrap">
      <Reveal>
        <p className="eyebrow">Trades we are recruiting</p>
        <div className="pill-cloud" data-testid="trades-cloud">
          {TRADES.map((t) => (
            <span
              key={t}
              className={t === "Other" ? "pill pill--other" : "pill"}
              data-testid={`trade-pill-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {t}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export const HowItWorks = () => (
  <section className="section" data-testid="how-it-works">
    <div className="wrap">
      <Reveal>
        <h2 className="section-title">How it works</h2>
      </Reveal>
      <div className="steps-grid">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="step-card" data-testid={`step-card-${i + 1}`}>
              <span className="step-num">{s.n}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const HonestColumns = () => (
  <section className="section" data-testid="honest-columns">
    <div className="wrap honest-grid">
      <Reveal>
        <div className="honest-col" data-testid="for-taskers">
          <p className="eyebrow">For taskers</p>
          <h3>You keep your business exactly as it is.</h3>
          <p>
            Sorted is not an employer and not an agency. You set your own prices,
            choose which jobs you accept, and keep working with your existing
            customers. Nothing here is exclusive.
          </p>
          <p>
            What we are asking for today is a place on the founding list and a
            phone conversation. There is no work to accept yet — the platform has
            not opened.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="honest-col" data-testid="for-clients">
          <p className="eyebrow">For clients</p>
          <h3>Not open for bookings yet.</h3>
          <p>
            When Sorted launches, you will be able to describe a job, see local
            professionals who can do it, and book a time. None of that is
            available today.
          </p>
          <p>
            If you would like to know when it opens, leave your email under
            "I need help" below. We will write to you once, at launch.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export const Priority = () => (
  <section className="section section--alt" data-testid="priority-section">
    <div className="wrap priority-grid">
      <Reveal>
        <div>
          <p className="eyebrow">Priority segment</p>
          <h2>Short-let and Airbnb property managers</h2>
          <p className="lede">
            Turnover cleaning, key handovers, repairs between guests: this is the
            work Malta needs most reliably, and the segment we are building around
            first. If you already manage properties or clean for them, we want your
            input before the platform is finished — how you schedule, what breaks,
            what a booking tool would have to get right.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="call-box" data-testid="call-box">
          <h3>What we discuss on the call</h3>
          <ul>
            {CALL_TOPICS.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
